import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { card, input, btnDanger, btnOutline } from "./UI";

const CONFIRM_WORD = "DELETE";

/**
 * A type-to-confirm destructive-action modal. Requires the admin to type
 * "DELETE" exactly before the confirm button becomes active -- a plain
 * window.confirm() is too easy to click through on autopilot.
 */
export default function ConfirmDeleteModal({ title, description, onConfirm, onCancel }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = typed === CONFIRM_WORD;

  const handleConfirm = async () => {
    if (!ready || busy) return;
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0,0,0,0.7)" }} onClick={onCancel}>
      <div style={{ ...card, maxWidth: 420, width: "100%", border: "1px solid rgba(248,113,113,0.25)" }}
        className="rounded-2xl p-6 shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-3">
          <div style={{ backgroundColor: "rgba(248,113,113,0.12)", color: "#F87171" }}
            className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0">
            <AlertTriangle size={18} />
          </div>
          <h2 className="text-white font-semibold">{title}</h2>
        </div>

        {description && (
          <p className="text-gray-400 text-sm mb-4">{description}</p>
        )}

        <label className="text-xs text-gray-400 mb-1.5 block">
          Type <span className="font-bold" style={{ color: "#F87171" }}>{CONFIRM_WORD}</span> to confirm
        </label>
        <input style={input}
          className="w-full rounded-lg p-2.5 text-sm focus:outline-none mb-4"
          value={typed} onChange={e => setTyped(e.target.value)}
          placeholder={CONFIRM_WORD} autoFocus />

        <div className="flex gap-2">
          <button onClick={handleConfirm} disabled={!ready || busy}
            style={btnDanger}
            className="flex-1 py-2.5 rounded-lg text-sm font-semibold transition-all disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-90">
            {busy ? "Deleting…" : "Delete"}
          </button>
          <button onClick={onCancel} style={btnOutline}
            className="px-5 py-2.5 rounded-lg text-sm transition-all">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
